/**
 * HomepageOptions - Available options for the intake homepage
 * Determines which booking flows are enabled
 */
export enum HomepageOptions {
  StartInPersonVisit = 'start-in-person-visit',
  ScheduleInPersonVisit = 'schedule-in-person-visit',
  StartVirtualVisit = 'start-virtual-visit',
  ScheduleVirtualVisit = 'schedule-virtual-visit',
}
